import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../components/sinpermisos";
import Nav from "react-bootstrap/Nav";
import "./Mislanding.css";

const url = "https://api.mrcirp.com/public/usuarios";
const urlCampanasAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";
const urldelete = "https://api.mrcirp.com/public/usuariosdelete";
const urldeleteCampanasAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";
const urleditar = "https://api.mrcirp.com/public/usuariosedit";

const Mislanding = () => {
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: "",
    usuario: "",
    descripcion: "",
    urlvideo: "",
    urlvideoproducto1: "",
    urlvideoproducto2: "",
    urlvideoproducto3: "",
    urlnegocio1: "",
    urlnegocio2: "",
    urlnegocio3: "",
    urlcomounirsecliente: "",
    urlcomoafiliarse: "",
    fecha: "",
    urlBotonProducto: "",
    urlBotonNegocio: "",
  });

  /////////////////Datatable/////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(data);
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  });

  const columns = [
    {
      name: "Accion",
      button: true,
      width: "200px",
      cell: (row) => (
        <div className="modern-action-buttons">
          <button
            onClick={() => {
              if (row.tipo === 'video') {
                window.open(`https://app.mrcirp.com/${row.usuario}`, "_blank");
              } else {
                // Para campañas de audiencia, abrir en nueva pestaña
                window.open(`https://apptest.mrcirp.com/audiencia/${row.usuario}`, "_blank");
              }
            }}
            className="modern-action-btn view"
            title="Ver landing"
          >
            <FaIcons.FaEye />
          </button>
          <button
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditaruser();
            }}
            className="modern-action-btn edit"
            title="Editar campaña"
          >
            <FaIcons.FaRegEdit />
          </button>
          <button
            onClick={() => {
              abrirModalContrasena(row);
            }}
            className="modern-action-btn lock"
            title="Establecer contraseña"
          >
            <FaIcons.FaLock />
          </button>
          <button
            className="modern-action-btn delete"
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditar();
            }}
            title="Eliminar campaña"
          >
            <FaIcons.FaTrash />
          </button>
        </div>
      ),
    },
    {
      name: "Id",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: "Tipo",
      selector: (row) => row.tipo,
      cell: (row) => (
        <span style={{
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: 'bold',
          color: 'white',
          backgroundColor: row.tipo === 'video' ? '#52c41a' : '#1890ff'
        }}>
          {row.tipo === 'video' ? '🎬 Video' : '👥 Audiencia'}
        </span>
      ),
    },
    {
      name: "Nombre de Campaña",
      selector: (row) => row.nombrecampana,
    },
    {
      name: "Enlace",
      selector: (row) => row.usuario,
    },
    {
      name: "Descripcion",
      selector: (row) => row.descripcion,
    },
  ];
  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
    const result = data.filter((resultdata) => {
      if (
        resultdata.usuario.toLowerCase().match(buscar.toLowerCase()) ||
        resultdata.descripcion.toLowerCase().match(buscar.toLowerCase()) ||
        (resultdata.nombrecampana && resultdata.nombrecampana.toLowerCase().match(buscar.toLowerCase()))
      ) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  ///////////////Insertar Datos//////////////////////////////////

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatosSeleccionados((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [Error, setError] = useState(false);

  /*   const peticionPost = async () => {
    delete datosSeleccionados.id;
    console.log(datosSeleccionados);
    await axios.post(url, datosSeleccionados).then(res => {
      peticionGet();
      setError(false);
     
    })
      .catch((err) => {
        setError(true);
        
      })
  }
 */
  //////////////Editar datos/////////////////////////////////////
  const [modalEditar, setModalEditar] = useState(false);
  const abrirModalEditar = () => {
    setModalEditar(true);
  };

  const peticionPut = async () => {
    try {
      let deleteUrl;
      
      // Determinar la URL de eliminación según el tipo de campaña
      if (datosSeleccionados.tipo === 'audiencia') {
        deleteUrl = urldeleteCampanasAudiencia + "/" + datosSeleccionados.id;
      } else {
        deleteUrl = urldelete + "/" + datosSeleccionados.id;
      }
      
      await axios.delete(deleteUrl, datosSeleccionados)
        .then((response) => {
          peticionGet();
          setError(false);
          setModalEditar(false);
        })
        .catch((err) => {
          console.error('Error al eliminar:', err);
          setError(true);
          setModalEditar(false);
        });
    } catch (error) {
      console.error('Error al eliminar campaña:', error);
      setError(true);
      setModalEditar(false);
    }
  };

  const [modalEditaruser, setModalEditaruser] = useState(false);
  const abrirModalEditaruser = () => {
    setModalEditaruser(true);
  };

  //////////////Estados para Modal de Contraseña/////////////////////////
  const [modalContrasena, setModalContrasena] = useState(false);
  const [contrasenaData, setContrasenaData] = useState({
    id: "",
    contrasena: "",
    confirmarContrasena: ""
  });
  const [mostrarContrasena, setMostrarContrasena] = useState(false);
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false);

  const abrirModalContrasena = (row) => {
    setContrasenaData({
      id: row.id,
      contrasena: "",
      confirmarContrasena: ""
    });
    setMostrarContrasena(false);
    setMostrarConfirmar(false);
    setModalContrasena(true);
  };

  const handleContrasenaChange = (e) => {
    const { name, value } = e.target;
    setContrasenaData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const guardarContrasena = async () => {
    if (!contrasenaData.contrasena || !contrasenaData.confirmarContrasena) {
      alert('Por favor completa todos los campos');
      return;
    }

    if (contrasenaData.contrasena !== contrasenaData.confirmarContrasena) {
      alert('Las contraseñas no coinciden');
      return;
    }

    if (contrasenaData.contrasena.length < 6) {
      alert('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    try {
      // Simulamos el guardado de la contraseña
      // En producción, aquí harías la llamada a la API
      console.log('Guardando contraseña para landing:', contrasenaData.id);
      console.log('Contraseña:', contrasenaData.contrasena);
      
      alert('Contraseña establecida exitosamente');
      setModalContrasena(false);
      setContrasenaData({
        id: "",
        contrasena: "",
        confirmarContrasena: ""
      });
      setMostrarContrasena(false);
      setMostrarConfirmar(false);
    } catch (error) {
      console.error('Error al guardar contraseña:', error);
      alert('Error al guardar la contraseña');
    }
  };

  const peticionPutuser = async () => {
    console.log(datosSeleccionados);
    await axios
      .put(urleditar + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        peticionGet();
        setError(false);
        setModalEditaruser(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setModalEditaruser(false);
      });
  };

  /////////////Mostrar datos//////////////////////////////////
  const peticionGet = async () => {
    console.log(users);
    try {
      // Obtener campañas de video (usuarios)
      const responseVideo = await axios.get(url);
      const filteredVideoData = responseVideo.data.filter(item => item.creador === users.id);
      
      // Obtener campañas de audiencia
      const responseAudiencia = await axios.get(urlCampanasAudiencia);
      const filteredAudienciaData = responseAudiencia.data.filter(item => item.admin_id === users.id);
      
      // Combinar ambas campañas y agregar tipo
      const videoCampaigns = filteredVideoData.map(item => ({
        ...item,
        tipo: 'video',
        nombre_campana: item.nombrecampana || 'Sin nombre',
        enlace_campana: item.usuario,
        fecha_creacion: item.fecha
      }));
      
      const audienciaCampaigns = filteredAudienciaData.map(item => ({
        ...item,
        tipo: 'audiencia',
        usuario: item.enlace_campana,
        nombrecampana: item.nombre_campana,
        fecha: item.fecha_creacion
      }));
      
      // Combinar todas las campañas
      const allCampaigns = [...videoCampaigns, ...audienciaCampaigns];
      
      setData(allCampaigns);
      setFiltroBuscar(allCampaigns);
    } catch (error) {
      console.error('Error al obtener campañas:', error);
      setData([]);
      setFiltroBuscar([]);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (users.id) {
      await peticionGet();
    }
  }, [users.id]);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "cliente") {
      return (
        <Sidebar>
        <div className="container">
         
            <Card className="modern-card">
              <Card.Header className="modern-card-header" as="h3">
                <div className="row">
                  <div className="col-md-12">🎯 Campañas Registradas</div>
                </div>
              </Card.Header>
              <Card.Body className="modern-card-body">
                <h2 className="modern-title">Mis Campañas</h2>
                {Error && (
                  <div className="modern-alert modern-alert-danger">
                    <strong>Error: El nombre ya existe! Intente con otro nombre.</strong>
                  </div>
                )}
                <p className="modern-subtitle">Gestiona todas tus campañas de landing page desde aquí.</p>
                <div className="modern-search-container">
                  <div className="position-relative">
                    <FaIcons.FaSearch className="modern-search-icon" />
                    <input
                      type="text"
                      placeholder="Buscar por nombre de campaña o enlace..."
                      className="modern-search-input"
                      value={buscar}
                      onChange={(e) => setBuscar(e.target.value)}
                    />
                  </div>
                </div>
                <DataTable
                  columns={columns}
                  data={filtrobuscar}
                  noDataComponent={
                    <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>
                      <FaIcons.FaSearch style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }} />
                      <p>No se encontraron campañas</p>
                    </div>
                  }
                  progressPending={pending}
                  progressComponent={<Cargando />}
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                  className="modern-datatable"
                  customStyles={{
                    table: {
                      style: {
                        borderRadius: '12px',
                        overflow: 'hidden'
                      }
                    }
                  }}
                />

                  <Modal isOpen={modalEditar} className="modern-modal">
                    <ModalHeader className="modern-modal-header">
                      <div>
                        <h4 className="modern-modal-title">🗑️ Eliminar Campaña</h4>
                      </div>
                    </ModalHeader>
                    <ModalBody className="modern-modal-body">
                      <input
                        className="modern-form-control"
                        readOnly
                        type="hidden"
                        name="id"
                        value={datosSeleccionados.id}
                        onChange={onchange}
                      />
                      <div className="modern-form-group">
                        <div className="modern-alert modern-alert-warning">
                          <strong>⚠️ Advertencia:</strong> Esta acción no se puede deshacer.
                        </div>
                        <h5 style={{ color: '#2d3748', marginBottom: '16px' }}>
                          ¿Está seguro de que desea eliminar la campaña <strong>#{datosSeleccionados.id}</strong>?
                        </h5>
                        <p style={{ color: '#718096', margin: 0 }}>
                          Se eliminará permanentemente: <strong>{datosSeleccionados.nombrecampana}</strong>
                        </p>
                      </div>
                    </ModalBody>
                    <ModalFooter className="modern-modal-footer">
                      <button
                        className="modern-btn modern-btn-secondary"
                        onClick={() => setModalEditar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="modern-btn modern-btn-danger"
                        onClick={() => peticionPut()}
                      >
                        <FaIcons.FaTrash /> Eliminar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalEditaruser} className="modern-modal">
                    <ModalHeader className="modern-modal-header">
                      <div>
                        <h5 className="modern-modal-title">✏️ Editar Campaña</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody className="modern-modal-body">
                      <div className="modern-form-group">
                        <input
                          className="modern-form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={datosSeleccionados.id}
                          onChange={handleChange}
                        />

                        <label className="modern-form-label">Descripción de la campaña</label>
                        <textarea
                          className="modern-form-control"
                          name="descripcion"
                          value={datosSeleccionados.descripcion}
                          onChange={handleChange}
                          rows="3"
                          placeholder="Describe tu campaña..."
                        />
                       
                        <label className="modern-form-label">URL del video principal</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideo"
                          value={datosSeleccionados.urlvideo}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                      
                        <label className="modern-form-label">URL Zona de revelación 1</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto1"
                          value={datosSeleccionados.urlvideoproducto1}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                      
                        <label className="modern-form-label">URL Zona de revelación 2</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto2"
                          value={datosSeleccionados.urlvideoproducto2}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                       
                        <label className="modern-form-label">URL Zona de revelación 3</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlvideoproducto3"
                          value={datosSeleccionados.urlvideoproducto3}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                       
                        <label className="modern-form-label">URL como unirse como cliente</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlcomounirsecliente"
                          value={datosSeleccionados.urlcomounirsecliente}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/unirse"
                        />
                      
                        <label className="modern-form-label">URL Botón Zona de revelación</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlBotonProducto"
                          value={datosSeleccionados.urlBotonProducto}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/boton"
                        />
                        
                        <label className="modern-form-label">URL zona de éxito 1</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio1"
                          value={datosSeleccionados.urlnegocio1}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                        
                        <label className="modern-form-label">URL zona de éxito 2</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio2"
                          value={datosSeleccionados.urlnegocio2}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                       
                        <label className="modern-form-label">URL zona de éxito 3</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlnegocio3"
                          value={datosSeleccionados.urlnegocio3}
                          onChange={handleChange}
                          placeholder="https://youtube.com/watch?v=..."
                        />
                    
                        <label className="modern-form-label">URL como afiliarse</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlcomoafiliarse"
                          value={datosSeleccionados.urlcomoafiliarse}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/afiliarse"
                        />
                         
                        <label className="modern-form-label">URL botón zona de éxito</label>
                        <input
                          className="modern-form-control"
                          type="text"
                          name="urlBotonNegocio"
                          value={datosSeleccionados.urlBotonNegocio}
                          onChange={handleChange}
                          placeholder="https://ejemplo.com/boton-exito"
                        />
                        
                      </div>
                    </ModalBody>
                    <ModalFooter className="modern-modal-footer">
                      <button
                        className="modern-btn modern-btn-secondary"
                        onClick={() => setModalEditaruser(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="modern-btn modern-btn-primary"
                        onClick={() => peticionPutuser()}
                      >
                        <FaIcons.FaSave /> Actualizar
                      </button>
                    </ModalFooter>
                  </Modal>

                  {/* Modal para establecer contraseña */}
                  <Modal isOpen={modalContrasena} className="modern-modal">
                    <ModalHeader className="modern-modal-header">
                      <div>
                        <h5 className="modern-modal-title">🔒 Establecer Contraseña para Landing</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody className="modern-modal-body">
                      <div className="modern-form-group">
                        <input
                          className="modern-form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={contrasenaData.id}
                        />
                        
                        <div className="modern-alert modern-alert-info">
                          <strong>ID de la Campaña:</strong> #{contrasenaData.id}
                        </div>

                        <label className="modern-form-label"><strong>Nueva Contraseña *</strong></label>
                        <div className="modern-input-group">
                          <input
                            className="modern-form-control"
                            type={mostrarContrasena ? "text" : "password"}
                            name="contrasena"
                            value={contrasenaData.contrasena}
                            onChange={handleContrasenaChange}
                            placeholder="Ingresa la nueva contraseña"
                            minLength="6"
                          />
                          <button
                            className="modern-btn"
                            type="button"
                            onClick={() => setMostrarContrasena(!mostrarContrasena)}
                            title={mostrarContrasena ? "Ocultar contraseña" : "Mostrar contraseña"}
                          >
                            {mostrarContrasena ? <FaIcons.FaEyeSlash /> : <FaIcons.FaEye />}
                          </button>
                        </div>
                        <small style={{ color: '#718096', fontSize: '0.75rem' }}>
                          Mínimo 6 caracteres
                        </small>

                        <label className="modern-form-label"><strong>Confirmar Contraseña *</strong></label>
                        <div className="modern-input-group">
                          <input
                            className="modern-form-control"
                            type={mostrarConfirmar ? "text" : "password"}
                            name="confirmarContrasena"
                            value={contrasenaData.confirmarContrasena}
                            onChange={handleContrasenaChange}
                            placeholder="Confirma la contraseña"
                            minLength="6"
                          />
                          <button
                            className="modern-btn"
                            type="button"
                            onClick={() => setMostrarConfirmar(!mostrarConfirmar)}
                            title={mostrarConfirmar ? "Ocultar contraseña" : "Mostrar contraseña"}
                          >
                            {mostrarConfirmar ? <FaIcons.FaEyeSlash /> : <FaIcons.FaEye />}
                          </button>
                        </div>

                        <div className="modern-alert modern-alert-warning">
                          <strong>⚠️ Importante:</strong> Una vez establecida la contraseña, 
                          los usuarios necesitarán ingresarla para acceder a esta landing.
                        </div>
                      </div>
                    </ModalBody>
                    <ModalFooter className="modern-modal-footer">
                      <button
                        className="modern-btn modern-btn-secondary"
                        onClick={() => setModalContrasena(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="modern-btn modern-btn-primary"
                        onClick={guardarContrasena}
                      >
                        <FaIcons.FaLock /> Establecer Contraseña
                      </button>
                    </ModalFooter>
                </Modal>
              </Card.Body>
            </Card>
        
        </div>
        </Sidebar>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Mislanding;